/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillProfileAssets} from '../api'

export const useMutationBackfillProfileAssets = createReactQueryMutationHook('backfillProfileAssets', backfillProfileAssets)
